export const Line = () => <div className="h-[1px] w-full bg-cool-gray-300" />;
